import React from 'react';
import Stack from '@mui/material/Stack';
import Tools from './Toolbar/Tools';
import UndoRedo from './Toolbar/UndoRedo';
import Actions from './Toolbar/Actions';
import Analysis from './Toolbar/Analysis';
import ModelSwitches from './Toolbar/ModelSwitches';
import InstallPWAButton from './InstallPWAButton';

export default function Toolbar() {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      sx={{ position: 'fixed', zIndex: 1, m: 1 }}
    >
      <Tools />
      <UndoRedo />
      <Actions />
      <ModelSwitches />
      <Analysis />
      <InstallPWAButton />
    </Stack>
  );
}
